import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-accounting-form',
  templateUrl: './accounting-form.component.html',
  styleUrls: ['./accounting-form.component.css'],
})
export class AccountingFormComponent {
  url: string = 'accountings';
  //urlTwo: string = 'personnel';
  id!: string;
  form!: FormGroup;
  frequencies: Array<any> = [];
  //personnel: Array<any> = [];
  //internal = false;
  //title = '';
  update = true;

  resumenCards = [
    {
      label: '',
      value: 0,
      icon: 'fas fa-users',
      bgClass: 'bg-white',
      desc: 'Staff &+',
      route: '/numbers/accounting',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-receipt',
      bgClass: 'bg-white',
      desc: 'Tax compliance',
      route: null,
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-receipt',
      bgClass: 'bg-white',
      desc: 'Invoices',
      route: '/numbers/accounting/invoices',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Bills',
      route: '/numbers/accounting/external',
    },
  ];

  resumenCardsTwo = [
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Finance',
      route: '/numbers',
    },
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-building-columns',
      bgClass: 'bg-white',
      desc: 'Accounting',
      route: '/numbers/accounting',
    },
  ];

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
  ) {
    this.form = this.fb.group({
      type: ['external', [Validators.required]],
      description: ['', [Validators.required]],
      value: ['', [Validators.required]],
      frequency: ['', [Validators.required]],
      dueDate: ['', [Validators.required]],
      //personnel: [''],
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];

      if (this.id) {
        this.getData();
        this.update = false;
      }

      this.frequencies = [
        { code: 1, name: 'ONE TIME' },
        { code: 2, name: 'DAILY' },
        { code: 3, name: 'WEEKLY' },
        { code: 4, name: 'MONTHLY' },
        { code: 5, name: 'YEARLY' },
      ];

      //console.log('URL actual:', this.router.url);
      const currentPath = this.router.url.split('/')[2];
      //console.log('path:', currentPath);

      /* if (currentPath === 'internal') {
        this.title = 'Salary';
        this.form.patchValue({
          type: 'internal',
        });
        this.internal = true;
        this.getPersonnel();
        this.setValidator();
        this.frequencies = [
          { code: 3, name: 'WEEKLY' },
          { code: 6, name: 'BIWEEKLY' },
          { code: 5, name: 'YEARLY' },
        ];
      } else {
        this.title = 'Payment';
        this.form.patchValue({
          type: 'external',
        });
        this.internal = false;
        this.frequencies = [
          { code: 1, name: 'ONE TIME' },
          { code: 2, name: 'DAILY' },
          { code: 3, name: 'WEEKLY' },
          { code: 4, name: 'MONTHLY' },
          { code: 5, name: 'YEARLY' },
        ];
      } */
      //console.log('type', this.form.value);
    });
  }

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }

  onSubmit(): void {
    if (this.id) {
      this.updateData();
    } else {
      this.createData();
    }
  }

  getData(): void {
    this.dataService.getData(`${this.url}/${this.id}`).subscribe((response) => {
      this.form.patchValue({
        description: response.description,
        value: response.value,
        frequency: response.frequency,
        dueDate: response.dueDate,
        //personnel: response.personnel,
      });
    });
  }

  createData(): void {
    const formData = {
      ...this.form.value,
    };

    this.dataService
      .postData(`${this.url}/add`, formData)
      .subscribe((response) => {
        console.log('response add', response);
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.router.navigateByUrl('/numbers/accounting/external');
          /* this.clearValidator();
          if (this.internal) {
            this.router.navigateByUrl('/numbers/accounting/internal');
          } else {
            this.router.navigateByUrl('/numbers/accounting/external');
          } */
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  updateData(): void {
    const formData = {
      ...this.form.value,
    };

    //console.log('formData up',formData)
    this.dataService
      .putData(`${this.url}/edit/${this.id}`, formData)
      .subscribe((response) => {
        console.log('response up', response);
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.router.navigateByUrl('/numbers/accounting/external');

          /* this.clearValidator();
          if (this.internal) {
            this.router.navigateByUrl('/numbers/accounting/internal');
          } else {
            this.router.navigateByUrl('/numbers/accounting/external');
          } */
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  /* getPersonnel(): void {
    this.dataService.getData(this.urlTwo).subscribe((response) => {
      this.personnel = response.data;
    });
  }

  setValidator() {
    const personnelControl = this.form.get('personnel');
    if (personnelControl) {
      personnelControl.setValidators([Validators.required]);
      personnelControl.updateValueAndValidity();
    }
  }

  clearValidator() {
    const personnelControl = this.form.get('personnel');
    if (personnelControl) {
      personnelControl.clearValidators();
      personnelControl.updateValueAndValidity();
    }
  } */

  enableUpdate() {
    this.update = !this.update;
  }
}
